import GoBackLeftArrow from '@/components/atoms/GoBackLeftArrow';
import DemographicsForm from '@/components/organisms/DemographicsForm';
import { CENTERED_FORM_WIDTH } from '@/constants/dimensions';
import useUpdateDemographics from '@/hooks/user/useUpdateDemographics';
import useToast from '@/hooks/useToast';
import { useAppStore } from '@/store/useAppStore';
import { TUser, TUserDemographicsInfo, TUserContactInfo, TDemographicsPayload } from '@/types/User.types';

import { Center, Text, VStack } from '@chakra-ui/react';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { useState } from 'react';

const ProfileDemographicsEdit = () => {
  const router = useRouter();
  const toast = useToast();

  const { user, setUser } = useAppStore();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmitSuccess = (user: TUser) => {
    setUser(user);

    toast({
      status: 'success',
      title: 'Success',
      description: 'User update successful!',
      position: 'top-right',
    });

    router.history.back();
  };

  const { mutate } = useUpdateDemographics(onSubmitSuccess);

  const onSubmit = async (data: TUserDemographicsInfo) => {
    setIsSubmitting(true);

    const {
      email,
      firstName,
      lastName,
      phone,
      eulaAccepted,
      profilePicture,
      picture,
      notificationPreferences,
      ...demographicsPayload
    } = data as TUserDemographicsInfo & TUserContactInfo & {
      picture?: string;
      notificationPreferences?: unknown;
    };

    // Explicitly acknowledge we're omitting these fields
    void email;
    void firstName;
    void lastName;
    void phone;
    void eulaAccepted;
    void profilePicture;
    void picture;
    void notificationPreferences;

    mutate(demographicsPayload as TDemographicsPayload);
  };

  return (
    <VStack marginBottom={100}>
      <GoBackLeftArrow />

      <Center height={'50px'}>
        <Text variant={'lora'} fontSize={'24px'} fontStyle={'italic'}>
          Edit Your Demographics
        </Text>
      </Center>

      <VStack maxWidth={{ md: CENTERED_FORM_WIDTH }} marginTop={'80px'}>
        <DemographicsForm
          defaultFormValues={user?.user_metadata as TUserDemographicsInfo}
          onSubmit={onSubmit}
          isLoading={isSubmitting}
        />
      </VStack>
    </VStack>
  );
};

export const Route = createFileRoute('/_authenticated/_user/_profile/user/profile/demographics')({
  staticData: { title: 'Demographics' },
  component: ProfileDemographicsEdit,
});
